'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.createChannelConstructor = createChannelConstructor;

var _sockjsClient = require('sockjs-client');

var _sockjsClient2 = _interopRequireDefault(_sockjsClient);

var _eventemitter = require('eventemitter3');

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var serverConnections = (0, _create2.default)(null);
var createdChannels = (0, _create2.default)(null);
var controlChannel = '0';

function createChannelConstructor(_addr, sessionId, _socketChannel) {
    var addr = _addr.toLowerCase();

    if (!serverConnections[addr]) {
        serverConnections[addr] = createNewConnection(addr, sessionId);
    }

    var socketChannel = _socketChannel;
    if (!socketChannel) {
        socketChannel = serverConnections[addr].nextChannelId++;
    }

    return createChannelOnConnection(serverConnections[addr], socketChannel);
}

function createNewConnection(wsAddr, sessionId) {
    var connection = new _eventemitter2.default();
    connection.sessionId = '';

    serverConnections[wsAddr] = connection;

    connection.nextChannelId = 1;
    connection.connected = false;

    connection.reconnect = connection.connect = function connect() {
        if (connection.ws) {
            try {
                connection.ws.close();
            } catch (err) {}

            connection.ws = null;
        }
        connection.ws = new _sockjsClient2.default(wsAddr);
        connection.ws.onopen = function () {
            var connectStr = sessionId ? 'CONTROL SESSION ' + sessionId : 'CONTROL START';
            connection.ws.send(':' + controlChannel + ' ' + connectStr);
            connection.connected = true;
            connection.emit('open');
        };
        connection.ws.onclose = function () {
            connection.connected = false;
            connection.ws = null;
            connection.emit('close');
        };
        connection.ws.onmessage = function (event) {
            connection.emit('message', event);

            if (event.data[0] === ':') {
                var message = event.data;
                var spacePos = message.indexOf(' ');

                if (spacePos === -1) {
                    connection.emit('open.' + message.substr(1));
                    return;
                }

                var channelId = message.substr(1, spacePos - 1);
                event.data = message.substr(spacePos + 1);
                connection.emit('message.' + channelId, event);
            } else {
                var parts = event.data.split(' ');

                if (parts[0] === 'SESSION') {
                    connection.sessionId = parts[1];
                }
            }
        };
    };

    connection.connect();
    return connection;
}

function createChannelOnConnection(connection, channelId) {
    return function ConnectionChannelWrapper(options) {
        if (!createdChannels[channelId]) {
            createdChannels[channelId] = new ConnectionChannel(options);
        } else if (connection.connected) {
            createdChannels[channelId].initChannel();
        }

        return createdChannels[channelId];
    };

    function ConnectionChannel(options) {
        var sendControlBuffer = [];
        var encoding = 'utf8';
        var channel = new _eventemitter2.default();
        channel.id = channelId;
        channel.isOpen = false;
        channel.state = 0;
        channel.remoteState = 0;

        connection.on('open', function () {
            connection.ws.send(':' + channelId);
        });

        connection.on('open.' + channelId, function () {
            channel.isOpen = true;

            if (sendControlBuffer.length) {
                sendControlBuffer.forEach(function (line) {
                    channel.sendControl(line);
                });
                sendControlBuffer = [];
            }

            channel.setEncoding(encoding);

            channel.remoteState = 1;
            channel.emit('open');
        });
        connection.on('close', function () {
            channel.state = 3;
            channel.remoteState = 0;
            channel.isOpen = false;
            channel.emit('close');
        });
        connection.on('message.' + channelId, function (event) {
            if (event.data.indexOf('control ') === 0) {
                if (event.data.indexOf('control connected') === 0) {
                    channel.remoteState = 1;
                }

                if (event.data.indexOf('control closed') === 0) {
                    var err = event.data.split(' ')[2];
                    channel.remoteState = 0;
                    channel.emit('close', err);
                }
            }

            if (channel.remoteState === 1) {
                channel.emit('line', event.data);
            }
        });

        channel.sendControl = function writeTarget(data) {
            if (channel.isOpen) {
                connection.ws.send(':' + channelId + ' ' + data);
            } else {
                sendControlBuffer.push(data);
            }
        };

        channel.writeLine = function writeTarget(data) {
            if (channel.remoteState >= 1) {
                connection.ws.send(':' + channelId + ' ' + data);
            }
        };

        channel.connect = function connect() {
            sendControlBuffer = [];

            if (!connection.ws) {
                connection.reconnect();
            }

            var host = options.host;
            var port = options.port;
            var tls = options.tls || options.ssl;
            channel.sendControl('HOST ' + host + ':' + (tls ? '+' : '') + port);
        };

        channel.close = function close() {
            if (channel.remoteState >= 1) {
                connection.ws.send(':' + channelId);
            }
        };

        channel.setEncoding = function setEncoding(newEncoding) {
            encoding = newEncoding;
            if (connection.connected) {
                connection.ws.send(':' + channelId + ' ENCODING ' + newEncoding);
            }
            return true;
        };

        channel.initChannel = function initChannel() {
            connection.ws.send(':' + channelId);
        };

        if (connection.connected) {
            channel.initChannel();
        }

        return channel;
    }
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ServerConnection"]
window._kiwi_exports.libs.ServerConnection = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/ServerConnection.js
// module id = wyE3
// module chunks = 1